import React, {
  FunctionComponent,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'
import Img from 'components/ui/Img'
import AvatarIcon from './components/avatar-icon/AvatarIcon'
import AvatarProps from './resources/AvatarProps.interface'
import { AvatarVariant, AvatarSizes } from './resources/Avatar.enum'
import AvatarDescription from './components/avatar-description/AvatarDescription'
import LoaderSrc from './assets/avatar-loading-xxl.svg'
import styles from './Avatar.module.scss'
/**
 * @visibleName Avatar
 * @version 1.0.0
 * @author [Rankmi](https://github.com/Rankmi)
 */
const Avatar: FunctionComponent<AvatarProps> = ({
  variant = AvatarVariant.Circle,
  sizes = AvatarSizes.Medium,
  src = LoaderSrc,
  imgAlt = 'Image name',
  color = '#ffffff',
  backgroundColor,
  borderColor,
  isLoading = false,
  icon,
  className,
  description,
  useOriginalImage = false,
}) => {
  const [imgSrc, setImgSrc] = useState(src || LoaderSrc)

  useEffect(() => {
    setImgSrc(src || LoaderSrc)
  }, [src])

  const image = (
    <Img
      src={imgSrc}
      alt={imgAlt}
      {...(useOriginalImage
        ? {}
        : {
            imageHandlerProps: {
              width: 50,
            },
          })}
      onError={() => {
        if (imgSrc !== LoaderSrc) setImgSrc(LoaderSrc)
      }}
    />
  )
  const Styles = {
    color: color,
    backgroundColor: backgroundColor,
    border: borderColor ? `2px solid ${borderColor}` : 'none',
  }
  const loaderImage = (
    <Img className={styles.loader} src={LoaderSrc} alt="Avatar loader" />
  )
  const [classNames, setClassNames] = useState('')
  useLayoutEffect(() => {
    setClassNames(
      [styles.container, styles[`${variant}`], styles[`${sizes}`], className]
        .filter((item) => item)
        .join(' ')
    )
  }, [className, variant, sizes])

  return (
    <div className={styles.avatarContainer}>
      <div className={classNames} style={Styles}>
        {isLoading && loaderImage}
        {icon ? <AvatarIcon icon={icon} /> : image}
      </div>
      {description && (
        <AvatarDescription
          name={description.primaryText}
          rol={description.secundaryText}
          identifier={description.thirdText}
        ></AvatarDescription>
      )}
    </div>
  )
}

export default Avatar
